import { useState, useContext, useEffect } from 'react'
import { AnexosContext } from '../../../contexts/anexosProvider';
import { getDadosAnexo, getComponentMap } from '../../General/Format/anexo'
import { BiX } from "react-icons/bi";

const Visualizar = ({ anexo, setAnexo, closeModal, onUpdated }) => {
    const { updateAnexo } = useContext(AnexosContext);
    const [type, setType] = useState('Geral');
    const [editedData, setEditedData] = useState({});

    useEffect(() => {
        setEditedData(anexo);
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditedData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleEditClick = () => {
        setType('Edit');
        setEditedData(anexo);
    };

    const handleSaveClick = async () => {
        let editedDataCopy = { ...editedData };
        delete editedDataCopy.nome_operadora
        let newAnexo = await updateAnexo(editedDataCopy);
        setAnexo(newAnexo);
        setType('Geral');
        if (typeof onUpdated === 'function') {
            onUpdated();
        }
    };

    const handleCancelClick = () => {
        setType('Geral');
    };

    const dados = getDadosAnexo(editedData);
    const componentMap = getComponentMap(
        closeModal,
        handleCancelClick,
        handleSaveClick,
        handleEditClick,
        handleInputChange,
    );
    return (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100 p-4'>
            <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col'>
                {/* Header */}
                <div className='flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700'>
                    <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
                        Anexo {anexo.nome}
                    </h1>
                    <button 
                        onClick={() => closeModal()} 
                        className='p-2 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors duration-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700'
                    >
                        <BiX className='w-6 h-6' />
                    </button>
                </div>

                {/* Content */}
                <div className='flex-1 overflow-auto p-6'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                        {dados.map((dado, index) => (
                            <div className='space-y-1' key={index}>
                                {componentMap[type](dado)}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Footer */}
                <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-3">
                    {componentMap[`buttons${type}`]()}
                </div>
            </div>
        </div>
    )
}

export default Visualizar
